import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function postUpVoteAnswer (id) {

	try {

		const url = `${baseURI}/answers/${id}/voteup/`;
		const response = await baseAPIRequest({
			url,
			params: { method: 'POST' }
		});
		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to upvote answer: ${error.message}`);

		}
		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default postUpVoteAnswer;
